import { SeV2QuestionStatus } from "../../../autogen/bff-api";

export const QUESTION_STATUS_COLORS: Record<SeV2QuestionStatus, { bg: string; fg: string }> = {
  [SeV2QuestionStatus.Unanswered]: { bg: "smChipAmberBg", fg: "smChipAmberFg" },
  [SeV2QuestionStatus.Answered]: { bg: "smChipBlueBg", fg: "smChipBlueFg" },
  [SeV2QuestionStatus.Published]: { bg: "smChipGreenBg", fg: "smChipGreenFg" },
};
